import React, { useState, useRef, useContext, useEffect } from "react";
import axios from "../../../../../axios/index";
import { Link } from "react-router-dom";

import { UserContext } from "../../../../Context/UserContextProvider";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { requestConsultantValidate } from "./requestConsultantValidate";

// modal
import AlreadySignedupModal from "../AlreadySignedupModal/AlreadySignedupModal";
import FormSentModal from "../AlreadySignedupModal/FormSentModal";

// styles
import styles from "./ConsultantSignupForm.module.css";
import Dstyles from "../../../SignUp/signUp.module.css";

// img
import homeIcon from "../../../../../assets/img/HomePage/AzarMelk.svg";
import sideIcon1 from "../../../../../assets/img/HomePage/Rectangle 36.svg";
import sideIcon2 from "../../../../../assets/img/HomePage/Rectangle 37.svg";
import BirthDatepicker from "./BirthDatepicker";

export default function ConsultantSignupForm() {
  const { userData, userToken, simpleUser, iranianIdentityCardValidation } = useContext(UserContext);
  const [isConsultant, setIsConsultant] = useState(false);
  const [errors, setErrors] = useState({});
  const fileRef = useRef();
  const [showModal, setShowModal] = useState(false);
  const [btnLoader, setBtnLoader] = useState(false);
  const [consultantInfo, setConsultantInfo] = useState({
    fullName: "",
    birthDate: "",
    education: "",
    phoneNumber: "",
    address: "",
    email: "",
    aboutMe: "",
    CV: undefined,
    nationalID: "",
    landlinePhone: "",
    dateChanged: false,
  });

  useEffect(() => {
    if (simpleUser.roles != "" && simpleUser.length != 0) {
      setIsConsultant(true);
    }
    setConsultantInfo({
      ...consultantInfo,
      fullName: userData?.fullName,
      phoneNumber: userData?.phoneNumber?.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d]),
    });
  }, []);

  useEffect(() => {
    setErrors(requestConsultantValidate(consultantInfo));
  }, [consultantInfo]);

  return (
    <>
      <AlreadySignedupModal show={isConsultant} onHide={() => setIsConsultant(false)} signupForm={true} />

      <FormSentModal show={showModal} onHide={() => setShowModal(false)} />

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      <div className="d-flex flex-column justify-content-center align-items-center vw-100 position-relative bg-white" dir="rtl">
        <div className={Dstyles.images}>
          <img className={Dstyles.sideIcon2} src={sideIcon2} alt="icon" />
          <img className={Dstyles.sideIcon1} src={sideIcon1} alt="icon" />
        </div>

        <div className="w-100 d-flex align-items-center justify-content-center py-3 my-3">
          <Link to="/" className="mt-4 mb-5" style={{ zIndex: "5" }}>
            <img src={homeIcon} alt="icon" />
          </Link>
        </div>
        <div className={`container w-75 d-flex flex-column align-items-center justify-content-start p-4 mb-5 ${styles.form_container}`}>
          <div className="w-100 text-center mt-3 mb-5">
            <h3 className={styles.top_title}>ثبت نام مشاوران</h3>
          </div>

          <div className="w-100 text-end mb-4 px-3">
            <h3 className={styles.title}>لطفا اطلاعات خودر را تکمیل کنید</h3>
          </div>

          <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap px-3 my-3">
            <div className={`w-50 d-flex flex-column align-items-start justify-content-center my-md-0 my-2 ${styles.input_container}`}>
              <h6 className={styles.input_title}>نام و نام‌خانوادگی</h6>
              <input
                className={styles.form_input}
                type="text"
                name="fullName"
                value={consultantInfo.fullName}
                // onChange={changeHandler}
              />
            </div>
            <BirthDatepicker setConsultantInfo={setConsultantInfo} date={consultantInfo.birthDate} />
          </div>

          <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap px-3 my-3">
            <div className={`w-50 d-flex flex-column align-items-start justify-content-center my-md-0 my-2 ${styles.input_container}`}>
              <h6 className={styles.input_title}>تحصیلات</h6>
              <input className={styles.form_input} type="text" name="education" value={consultantInfo.education} onChange={changeHandler} />
            </div>
            <div className={`w-50 d-flex flex-column align-items-start justify-content-center my-md-0 my-2 ${styles.input_container}`}>
              <h6 className={styles.input_title}>شماره تماس</h6>
              <input
                className={styles.form_input}
                type="text"
                name="phoneNumber"
                value={consultantInfo.phoneNumber}
                // onChange={changeHandler}
                // onKeyDown={removeSymbolNumberHandler}
              />
            </div>
          </div>

          <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap px-3 my-3">
            <div className={`w-50 d-flex flex-column align-items-start justify-content-center my-md-0 my-2 ${styles.input_container}`}>
              <h6 className={styles.input_title}>آدرس</h6>
              <input className={styles.form_input} type="text" name="address" value={consultantInfo.address} onChange={changeHandler} />
            </div>
            <div className={`w-50 d-flex flex-column align-items-start justify-content-center my-md-0 my-2 ${styles.input_container}`}>
              <h6 className={styles.input_title}>فایل رزومه</h6>
              <div className={`d-flex align-items-center justify-content-between px-3 pointer ${styles.form_input}`} onClick={() => fileRef.current.click()}>
                <input type="file" name="CV" onChange={changeHandler} ref={fileRef} hidden />
                <div className={consultantInfo.CV === undefined ? styles.upload_text : styles.uploaded_text}>
                  {consultantInfo.CV === undefined ? "فایل خود را بارگذاری کنید" : "فایل با موفقیت اضافه شد"}
                </div>
                <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.51884 1.26884C2.01113 0.776562 2.67881 0.5 3.375 0.5H14.625C15.3212 0.5 15.9889 0.776562 16.4812 1.26884C16.9734 1.76113 17.25 2.42881 17.25 3.125V12.875C17.25 13.5712 16.9734 14.2389 16.4812 14.7312C15.9889 15.2234 15.3212 15.5 14.625 15.5H12.75C12.3358 15.5 12 15.1642 12 14.75C12 14.3358 12.3358 14 12.75 14H14.625C14.9234 14 15.2095 13.8815 15.4205 13.6705C15.6315 13.4595 15.75 13.1734 15.75 12.875V3.125C15.75 2.82663 15.6315 2.54048 15.4205 2.3295C15.2095 2.11853 14.9234 2 14.625 2H3.375C3.07663 2 2.79048 2.11853 2.5795 2.3295C2.36853 2.54048 2.25 2.82663 2.25 3.125V12.875C2.25 13.1734 2.36853 13.4595 2.5795 13.6705C2.79048 13.8815 3.07663 14 3.375 14H5.25C5.66421 14 6 14.3358 6 14.75C6 15.1642 5.66421 15.5 5.25 15.5H3.375C2.67881 15.5 2.01113 15.2234 1.51884 14.7312C1.02656 14.2389 0.75 13.5712 0.75 12.875V3.125C0.75 2.42881 1.02656 1.76113 1.51884 1.26884ZM8.46967 5.96967C8.76256 5.67678 9.23744 5.67678 9.53033 5.96967L13.2803 9.71967C13.5732 10.0126 13.5732 10.4874 13.2803 10.7803C12.9874 11.0732 12.5126 11.0732 12.2197 10.7803L9.75 8.31066V20.75C9.75 21.1642 9.41421 21.5 9 21.5C8.58579 21.5 8.25 21.1642 8.25 20.75V8.31066L5.78033 10.7803C5.48744 11.0732 5.01256 11.0732 4.71967 10.7803C4.42678 10.4874 4.42678 10.0126 4.71967 9.71967L8.46967 5.96967Z"
                    fill="#21409A"
                  />
                </svg>
              </div>
            </div>
          </div>

          <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap px-3 my-3">
            <div className={`w-50 d-flex flex-column align-items-start justify-content-center my-md-0 my-2 ${styles.input_container}`}>
              <h6 className={styles.input_title}>ایمیل</h6>
              <input className={styles.form_input} type="text" name="email" value={consultantInfo.email} onChange={changeHandler} />
            </div>
            <div className={`w-50 d-flex flex-column align-items-start justify-content-center my-md-0 my-2 ${styles.input_container}`}>
              <h6 className={styles.input_title}>کدملی</h6>
              <input className={styles.form_input} type="text" name="nationalID" value={consultantInfo.nationalID} onChange={changeHandler} />
            </div>
          </div>

          <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap px-3 my-3">
            <div className={`w-50 d-flex flex-column align-items-start justify-content-center my-md-0 my-2 ${styles.input_container}`}>
              <h6 className={styles.input_title}>تلفن ثابت (با کد شهر)</h6>
              <input className={styles.form_input} type="text" name="landlinePhone" value={consultantInfo.landlinePhone} onChange={changeHandler} />
            </div>
          </div>

          <div className="w-100 d-flex align-items-center justify-content-center flex-wrap px-3 my-3">
            <div className="w-100 d-flex flex-column align-items-start justify-content-center">
              <h6 className={styles.input_title}>توضیحات</h6>
              <textarea
                type="text"
                name="aboutMe"
                value={consultantInfo.aboutMe}
                onChange={changeHandler}
                className={`w-100 px-3 pt-3 ${styles.textarea}`}
                placeholder="توضیحات خود را وارد کنید"></textarea>
            </div>
          </div>

          <div className="w-100 text-center my-3">
            {btnLoader ? (
              <div className={styles.btn_loader_container}>
                <div className={styles.btn_spinner}></div>
              </div>
            ) : (
              <button className={styles.submit_btn} type="" onClick={submitHandler}>
                ثبت نام
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );

  function changeHandler(e) {
    if (e.target.name === "CV") {
      const file = e.target.files[0];
      if (file.size > 500000) {
        // check if file size is more than 500kb
        notify("حجم فایل نباید بیشتر از 500 کیلوبایت باشد", "error");
        return;
      } else {
        setConsultantInfo(prev => {
          return { ...prev, CV: file };
        });
      }
    } else {
      setConsultantInfo(prev => {
        return { ...prev, [e.target.name]: e.target.value };
      });
    }
  }

  function submitHandler() {
    if (!Object.keys(errors).length) {
      notify("درحال ارسال درخواست", "success");
    } /*else if (iranianIdentityCardValidation(consultantInfo.nationalID?.toString()) === false) {
            notify("کدملی اشتباه است", "error")
        }*/ else {
      notify("!لطفا تمام فیلد هارا پرکنید", "error");
    }
  }

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      postHandler();
    } else if (type === "successed") {
      toast.success(text, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setBtnLoader(false);
    }
  }

  async function postHandler() {
    const { nationalID, education, address, email, aboutMe, CV, landlinePhone, birthDate } = consultantInfo;
    setBtnLoader(true);
    try {
      const data = new FormData();
      data.append("Birthdate", `${birthDate?.year}/${birthDate?.month?.number}/${birthDate?.day}`);
      data.append("NationalId", nationalID);
      data.append("Education", education);
      data.append("Address", address);
      data.append("Email", email ? email : null);
      data.append("AboutMe", aboutMe);
      data.append("CvImageName", CV);
      data.append("LandlinePhone", landlinePhone);

      const apiData = await axios.post("Consultant", data, {
        headers: { authorization: "Bearer " + userToken },
      });
      // console.log(apiData);
      setBtnLoader(false);
      setShowModal(true);
      notify("درخواست شما فرستاده شد", "successed");
    } catch (error) {
      // console.log(error);
      notify(error.response.data.metaData.message, "error");
      setBtnLoader(false);
    }
  }
}
